import { apiClient } from "@/lib/apiClient";

export interface VendingData {
  productStockId: string;
  productId: string;
  quantity: number;
  label: string;
  vendedAt: string;
  accountId: string;
  price: number;
}

export interface Vending extends VendingData {
  id: string;
  productName: string;
  createdByUserId: string;
  createdAt: string;
  currency: string;
}

/** The product and the stock of a sale are fixed; the rest can be corrected. */
export type UpdateVendingPayload = {
  label?: string;
  vendedAt?: string;
  quantity?: number;
  price?: number;
};

export type DeletedVending = Vending & {
  isDeleted: boolean;
  deletedAt: string | null;
  /** Account balance once the sale has been reverted. */
  accountBalance: number;
};

export const VENDINGS_KEY = "vending";

export const listVendings = async (): Promise<Vending[]> => {
  const data = await apiClient.get<Vending[]>(VENDINGS_KEY);
  return Array.isArray(data) ? data : [];
};

export const createVending = (data: VendingData): Promise<Vending> => apiClient.post<Vending>(VENDINGS_KEY, data);

export const updateVending = (id: string, payload: UpdateVendingPayload): Promise<Vending> =>
  apiClient.put<Vending>(`vending/${id}`, payload);

export const deleteVending = (id: string): Promise<DeletedVending> => apiClient.delete<DeletedVending>(`vending/${id}`);
